var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticStyle:{"width":"auto","height":"580px","margin-left":"28%"},attrs:{"src":require("../../assets/images/404.png")}})])
}]

export { render, staticRenderFns }